export default function (time) {
  if (!time) {
    return time
  }

  return time.padStart(5, 0)
}
